import { getData as getDataOauth2 } from '@gef-ui/middleware-api/auth/oauth2/facade';
import { getData as getDataRefresh } from '@gef-ui/middleware-api/auth/refresh/facade';
import { getRestUrl } from '@gef-ui/middleware-api/facade';
import { createAction } from '@gef-ui/utils/fsaActions';
import { codelistActionTypes } from '../constants';
const DEFAULT_CONTEXT = 'code-table';
/**
 * Register codelist with specified store key name
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(clearCodelistInStore('storeKey'));
 *
 */ export const registerCodelist = (storeKey)=>createAction(codelistActionTypes.CODELIST_LOAD_DATA_REGISTER, ()=>({
            codelistStoreKey: storeKey
        }));
/**
 * Call codelist API  codelist with specified store key name
 *
 * It is possible to extend anything related to actual API call using settings object
 * {
 * 	name[string],
 * 	keepData[boolean],
 * 	endpoint[string],
 * 	searchText[string],
 * 	parentFilter[string],
 * 	codelistContext[string] = DEFAULT_CONTEXT,
 * 	parentFilterUrlParam[string],
 * 	searchTextUrlParam[string],
 * 	callCodelistApiRemoteDataConverter[Function(body)],
 * 	credentials[string]
 * }
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(clearCodelistInStore('storeKey', true)({}));
 *
 */ export const callCodelistAPI = (storeKey, oauth2)=>(settings)=>(oauth2 ? getDataOauth2 : getDataRefresh)({
            endpoint: ({ urls })=>getRestUrl(settings.endpoint ? settings.endpoint : urls.codelist, {
                    pathVariables: {
                        [settings.codelistContext ?? urls.codelistContext ?? DEFAULT_CONTEXT]: settings.name,
                        [settings.parentFilterUrlParam]: settings.parentFilter,
                        [settings.searchTextUrlParam]: settings.searchText
                    }
                }),
            actions: {
                onRequest: createAction(codelistActionTypes.CODELIST_LOAD_DATA_REQUEST, ()=>({
                        codelistStoreKey: storeKey,
                        keepData: settings.keepData
                    })),
                onSuccess: createAction(codelistActionTypes.CODELIST_LOAD_DATA_SUCCESS, ({ body })=>({
                        codelistStoreKey: storeKey,
                        codelistData: settings.callCodelistApiRemoteDataConverter ? settings.callCodelistApiRemoteDataConverter(body) : body.values
                    })),
                onError: createAction(codelistActionTypes.CODELIST_LOAD_DATA_FAIL, ()=>({
                        codelistStoreKey: storeKey
                    }))
            },
            credentials: settings.credentials ? settings.credentials : undefined
        });
/**
 * Clear codelist values for specified key
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(clearCodelistInStore('storeKey'));
 *
 */ export const clearCodelistInStore = (storeKey)=>createAction(codelistActionTypes.CODELIST_DATA_CLEAR, ()=>({
            codelistStoreKey: storeKey
        }));
